import { createFileRoute } from "@tanstack/react-router";

import { ProtocolPrintView } from "@/features/receptura/protocol-print";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/receptura/protokoly_/$id_/drukuj")({
	component: ProtocolPrintRoute,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.receptura.protokoly",
			location.pathname,
		);
	},
});

function ProtocolPrintRoute() {
	const { id } = Route.useParams();
	return <ProtocolPrintView protocolId={Number(id)} />;
}
